"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  TouchId4: ['touch-id-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.015,12.015,0,0,0,12,0Zm0,16.32a1.961,1.961,0,0,0,1.958-1.959V9.64a1.958,1.958,0,1,0-3.916,0v1.416a.875.875,0,0,1-1.75,0V9.64a3.708,3.708,0,1,1,7.416,0v4.721a3.708,3.708,0,1,1-7.416,0,.875.875,0,0,1,1.75,0A1.961,1.961,0,0,0,12,16.32Zm-.875-2.43V11.056a.875.875,0,1,1,1.75,0V13.89a.875.875,0,0,1-1.75,0Zm-2.7-7.445a4.78,4.78,0,0,0-1.221,3.2v4.721a4.792,4.792,0,0,0,8.364,3.2.875.875,0,1,1,1.3,1.167A6.542,6.542,0,0,1,5.458,14.361V9.64A6.528,6.528,0,0,1,7.125,5.277a.875.875,0,0,1,1.3,1.168Zm10.113,7.916a.875.875,0,1,1-1.75,0V9.64A4.8,4.8,0,0,0,10.5,5.085a.875.875,0,0,1-.546-1.662A6.547,6.547,0,0,1,18.542,9.64Z']],
  TouchIdApproved1: ['touch-id-approved-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,12,11Zm3.474,5.355-2.9,3.874a1.751,1.751,0,0,1-2.64.185l-1.5-1.5A1,1,0,0,1,9.844,17.5L10.938,18.6a.251.251,0,0,0,.377-.027l2.559-3.412a1,1,0,1,1,1.6,1.2Z', 'M10.671,3.988a4.8,4.8,0,0,1,6.287,4.554V11.1a.248.248,0,0,0,.093.194,8.082,8.082,0,0,1,1.212,1.227.25.25,0,0,0,.445-.156V8.542a6.543,6.543,0,0,0-8.583-6.216.875.875,0,1,0,.546,1.662Z', 'M7.273,11.046a.251.251,0,0,0,.1-.2v-2.3A4.779,4.779,0,0,1,8.6,5.348a.875.875,0,0,0-1.3-1.168A6.528,6.528,0,0,0,5.625,8.542v3.432a.25.25,0,0,0,.436.167A8.029,8.029,0,0,1,7.273,11.046Z', 'M10.02,9.748a.25.25,0,0,0,.188-.243V8.542a1.959,1.959,0,1,1,3.917,0V9.6a.25.25,0,0,0,.178.239,8,8,0,0,1,1.212.475.25.25,0,0,0,.36-.224V8.542a3.709,3.709,0,1,0-7.417,0V9.958a.234.234,0,0,0,.328.214A7.877,7.877,0,0,1,10.02,9.748Z', 'M5.459,22.106A.253.253,0,0,0,5.254,22h-3A.249.249,0,0,1,2,21.75V2.25A.25.25,0,0,1,2.25,2H6.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H6.5a.959.959,0,0,0,.142-.01.249.249,0,0,0,.128-.436A8.018,8.018,0,0,1,5.459,22.106Z', 'M24,2a2,2,0,0,0-2-2H17.5a1,1,0,0,0,0,2h4.25a.25.25,0,0,1,.25.25v19.5a.249.249,0,0,1-.25.25h-3a.253.253,0,0,0-.2.106,8.018,8.018,0,0,1-1.311,1.448.25.25,0,0,0,.128.436A.959.959,0,0,0,17.5,24H22a2,2,0,0,0,2-2Z']],
  TouchId2: ['touch-id-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.671,5.112a4.8,4.8,0,0,1,6.287,4.555v4.722a.875.875,0,0,0,1.75,0V9.667A6.546,6.546,0,0,0,10.125,3.45a.875.875,0,1,0,.546,1.662Z', 'M17.042,18.751a.875.875,0,1,0-1.3-1.168,4.791,4.791,0,0,1-8.363-3.194V9.667A4.777,4.777,0,0,1,8.6,6.473a.875.875,0,1,0-1.3-1.168A6.528,6.528,0,0,0,5.625,9.667v4.722a6.542,6.542,0,0,0,11.417,4.362Z', 'M10.208,14.389a.875.875,0,0,0-1.75,0,3.709,3.709,0,1,0,7.417,0V9.667a3.709,3.709,0,1,0-7.417,0v1.416a.875.875,0,0,0,1.75,0V9.667a1.959,1.959,0,1,1,3.917,0v4.722a1.959,1.959,0,1,1-3.917,0Z', 'M13.042,13.917V11.083a.875.875,0,0,0-1.75,0v2.834a.875.875,0,0,0,1.75,0Z', 'M6.5,22H2.25A.25.25,0,0,1,2,21.75V17.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H6.5a1,1,0,0,0,0-2Z', 'M1,7.5a1,1,0,0,0,1-1V2.25A.25.25,0,0,1,2.25,2H6.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V6.5A1,1,0,0,0,1,7.5Z', 'M23,16.5a1,1,0,0,0-1,1v4.25a.25.25,0,0,1-.25.25H17.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V17.5A1,1,0,0,0,23,16.5Z', 'M22,0H17.5a1,1,0,0,0,0,2h4.25a.25.25,0,0,1,.25.25V6.5a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z']],
  TouchId: ['touch-id', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3,12.625a.875.875,0,0,0-.875.875V23a.875.875,0,0,0,1.75,0V13.5A.875.875,0,0,0,3,12.625Z', 'M12,1.875a8.1,8.1,0,0,1,4.492,1.353A.875.875,0,1,0,17.46,1.77,9.877,9.877,0,0,0,2.125,10a.875.875,0,0,0,1.75,0A8.134,8.134,0,0,1,12,1.875Z', 'M20.211,4.513a.875.875,0,1,0-1.454.974A8.081,8.081,0,0,1,20.125,10V23a.875.875,0,0,0,1.75,0V10A9.828,9.828,0,0,0,20.211,4.513Z', 'M12,3.125A6.883,6.883,0,0,0,5.125,10V23a.875.875,0,0,0,1.75,0V10a5.125,5.125,0,0,1,10.25,0v6.5a.875.875,0,0,0,1.75,0V10A6.883,6.883,0,0,0,12,3.125Z', 'M18,19.125a.875.875,0,0,0-.875.875v3a.875.875,0,0,0,1.75,0V20A.875.875,0,0,0,18,19.125Z', 'M9,17.625a.875.875,0,0,0-.875.875V23a.875.875,0,0,0,1.75,0V18.5A.875.875,0,0,0,9,17.625Z', 'M12,6.125A3.879,3.879,0,0,0,8.125,10v5a.875.875,0,0,0,1.75,0V10a2.125,2.125,0,0,1,4.25,0V23a.875.875,0,0,0,1.75,0V10A3.879,3.879,0,0,0,12,6.125Z', 'M12,10.125a.875.875,0,0,0-.875.875v7a.875.875,0,0,0,1.75,0V11A.875.875,0,0,0,12,10.125Z', 'M12,20.625a.875.875,0,0,0-.875.875V23a.875.875,0,0,0,1.75,0V21.5A.875.875,0,0,0,12,20.625Z']],
  TouchIDLock: ['touch-id-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.038,21.26a7.628,7.628,0,0,1-2.663.476.75.75,0,0,0,0,1.5,9.29,9.29,0,0,0,2.826-.442.249.249,0,0,0,.174-.238V21.5a.25.25,0,0,0-.337-.235Z', 'M17.125,9.267v.076a.251.251,0,0,0,.3.245,4.373,4.373,0,0,1,.946-.1h.03a.22.22,0,0,0,.22-.219A9.154,9.154,0,0,0,16.7,3.616a.748.748,0,0,0-1.05-.139.739.739,0,0,0-.13,1.049A7.736,7.736,0,0,1,17.125,9.267Z', 'M6.361,21.129a7.74,7.74,0,0,1-4.736-7.143V12.1a.75.75,0,0,0-1.5,0v1.888A9.235,9.235,0,0,0,5.777,22.51a.74.74,0,0,0,.292.059.75.75,0,0,0,.292-1.44Z', 'M.847,9.542H.889a.75.75,0,0,0,.748-.709A7.751,7.751,0,0,1,13.252,2.553.75.75,0,0,0,14,1.254,9.252,9.252,0,0,0,.139,8.752.75.75,0,0,0,.847,9.542Z', 'M14.467,11.411a.251.251,0,0,0,.28-.091,4.256,4.256,0,0,1,.944-.941.252.252,0,0,0,.1-.2V9.267a6.419,6.419,0,0,0-8.42-6.1.747.747,0,0,0-.48.95.756.756,0,0,0,.94.48,4.733,4.733,0,0,1,1.54-.25A4.93,4.93,0,0,1,14.3,9.267v1.906A.25.25,0,0,0,14.467,11.411Z', 'M12.245,18.138a.249.249,0,0,0-.254.008,4.88,4.88,0,0,1-2.616.76,4.929,4.929,0,0,1-4.92-4.92V9.267a4.95,4.95,0,0,1,1.25-3.281.746.746,0,0,0-.05-1.06.755.755,0,0,0-1.06.06,6.4,6.4,0,0,0-1.64,4.281v4.719a6.427,6.427,0,0,0,6.42,6.42,6.279,6.279,0,0,0,2.864-.688.251.251,0,0,0,.136-.222V18.357A.25.25,0,0,0,12.245,18.138Z', 'M9.375,5.676A3.585,3.585,0,0,0,5.8,9.267v1.409a.75.75,0,0,0,1.5,0V9.267a2.08,2.08,0,1,1,4.16,0v4.719a2.08,2.08,0,1,1-4.16,0,.75.75,0,0,0-1.5,0,3.58,3.58,0,0,0,6.55,2,.253.253,0,0,0,.042-.127,1.842,1.842,0,0,1,.46-1.143.233.233,0,0,0,.061-.127,3.886,3.886,0,0,0,.047-.6V9.267A3.585,3.585,0,0,0,9.375,5.676Z', 'M10.125,13.514V10.681a.75.75,0,1,0-1.5,0v2.833a.75.75,0,0,0,1.5,0Z', 'M22.589,15.5a.25.25,0,0,1-.214-.248V14.236a3.5,3.5,0,0,0-7,0v1.018a.25.25,0,0,1-.214.248,1.5,1.5,0,0,0-1.286,1.484v5.5a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5v-5.5A1.5,1.5,0,0,0,22.589,15.5Zm-3.714,5.734a1,1,0,1,1,1-1A1,1,0,0,1,18.875,21.236Zm1.5-6a.249.249,0,0,1-.25.25h-2.5a.249.249,0,0,1-.25-.25v-1a1.5,1.5,0,0,1,3,0Z']],
  TouchFinger1: ['touch-finger-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.712,12.944a1,1,0,0,0,1.571-1.237,6,6,0,1,1,9.4.045,1,1,0,0,0,.154,1.406A1.013,1.013,0,0,0,17.247,13,8,8,0,1,0,3,8,8.248,8.248,0,0,0,4.712,12.944Z', 'M16.385,17H13.5V10.5a2.5,2.5,0,0,0-5,0v8.835L7.409,17.808A2.075,2.075,0,1,0,3.737,19.74l2.1,3.993A.5.5,0,0,0,6.281,24H20.5a.5.5,0,0,0,.5-.5V21.848A4.8,4.8,0,0,0,16.385,17Z']],
  TouchIDDesktop: ['touch-id-desktop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5V1.5A1.5,1.5,0,0,0,22.5,0ZM22,14.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M12,3.25a4.243,4.243,0,0,0-2.191.608.75.75,0,0,0,.774,1.285A2.75,2.75,0,0,1,14.75,7.5v2a2.727,2.727,0,0,1-.264,1.178.75.75,0,0,0,1.354.645A4.218,4.218,0,0,0,16.25,9.5v-2A4.255,4.255,0,0,0,12,3.25Z', 'M12.787,12.137A2.789,2.789,0,0,1,12,12.25,2.752,2.752,0,0,1,9.25,9.5v-2a2.742,2.742,0,0,1,.114-.786.75.75,0,0,0-1.438-.428A4.249,4.249,0,0,0,7.75,7.5v2a4.255,4.255,0,0,0,5.463,4.075.75.75,0,0,0-.426-1.438Z', 'M13,9.625A.625.625,0,0,0,13.625,9V7.5A1.627,1.627,0,0,0,12,5.875a.625.625,0,0,0,0,1.25.375.375,0,0,1,.375.375V9A.625.625,0,0,0,13,9.625Z', 'M10.375,8V9.5A1.626,1.626,0,0,0,12,11.125a.625.625,0,0,0,0-1.25.375.375,0,0,1-.375-.375V8a.625.625,0,0,0-1.25,0Z']],
  TouchIdDenied: ['touch-id-denied', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.732,21.908a.5.5,0,0,0-.481-.226,7.2,7.2,0,0,1-.876.054.75.75,0,0,0,0,1.5,9.344,9.344,0,0,0,1.764-.167.252.252,0,0,0,.189-.162.248.248,0,0,0-.045-.245A7.209,7.209,0,0,1,10.732,21.908Z', 'M17.125,9.267a.22.22,0,0,0,.22.219h.03a7.711,7.711,0,0,1,.969.059.251.251,0,0,0,.281-.249V9.267A9.154,9.154,0,0,0,16.7,3.616a.748.748,0,0,0-1.05-.139.739.739,0,0,0-.13,1.049A7.736,7.736,0,0,1,17.125,9.267Z', 'M6.361,21.129a7.74,7.74,0,0,1-4.736-7.143V12.1a.75.75,0,0,0-1.5,0v1.888A9.235,9.235,0,0,0,5.777,22.51a.74.74,0,0,0,.292.059.75.75,0,0,0,.292-1.44Z', 'M.847,9.542H.889a.75.75,0,0,0,.748-.709A7.751,7.751,0,0,1,13.252,2.553.75.75,0,0,0,14,1.254,9.252,9.252,0,0,0,.139,8.752.75.75,0,0,0,.847,9.542Z', 'M14.4,9.944a.248.248,0,0,0,.23.03,8.456,8.456,0,0,1,.994-.3.218.218,0,0,0,.169-.213V9.267a6.419,6.419,0,0,0-8.42-6.1.747.747,0,0,0-.48.95.756.756,0,0,0,.94.48,4.733,4.733,0,0,1,1.54-.25A4.93,4.93,0,0,1,14.3,9.267v.472A.249.249,0,0,0,14.4,9.944Z', 'M5.705,5.986a.746.746,0,0,0-.05-1.06.755.755,0,0,0-1.06.06,6.4,6.4,0,0,0-1.64,4.281v4.719a6.427,6.427,0,0,0,6.42,6.42c.068,0,.138,0,.209,0a.25.25,0,0,0,.225-.333,7.323,7.323,0,0,1-.278-1.034.159.159,0,0,0-.156-.129,4.929,4.929,0,0,1-4.92-4.92V9.267A4.95,4.95,0,0,1,5.705,5.986Z', 'M9.294,17.566a.08.08,0,0,0,.081-.08,7.656,7.656,0,0,1,.105-1.3.107.107,0,0,0-.105-.124A2.079,2.079,0,0,1,7.3,13.986a.75.75,0,0,0-1.5,0A3.576,3.576,0,0,0,9.294,17.566Z', 'M11.606,11.731a.251.251,0,0,0,.271-.049,7.832,7.832,0,0,1,.969-.782.252.252,0,0,0,.109-.207V9.267a3.58,3.58,0,1,0-7.16,0v1.409a.75.75,0,0,0,1.5,0V9.267a2.08,2.08,0,1,1,4.16,0V11.5A.252.252,0,0,0,11.606,11.731Z', 'M10.125,13.514V10.681a.75.75,0,1,0-1.5,0v2.833a.75.75,0,0,0,1.5,0Z', 'M17.375,10.986a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.375,10.986Zm1.591,6.677L20.2,18.9a1,1,0,1,1-1.414,1.414l-1.237-1.238a.252.252,0,0,0-.354,0l-1.237,1.238A1,1,0,0,1,14.547,18.9l1.237-1.238a.249.249,0,0,0,0-.353l-1.237-1.238a1,1,0,0,1,1.414-1.414L17.2,15.9a.252.252,0,0,0,.354,0l1.237-1.238A1,1,0,1,1,20.2,16.072L18.966,17.31A.249.249,0,0,0,18.966,17.663Z']],
  TouchIdDenied1: ['touch-id-denied-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.671,3.988a4.8,4.8,0,0,1,6.288,4.554V11.1a.251.251,0,0,0,.092.194,8.036,8.036,0,0,1,1.212,1.227.25.25,0,0,0,.446-.156V8.542a6.544,6.544,0,0,0-8.584-6.216.875.875,0,0,0,.546,1.662Z', 'M7.273,11.046a.251.251,0,0,0,.1-.2v-2.3A4.779,4.779,0,0,1,8.6,5.348a.875.875,0,0,0-1.3-1.168A6.528,6.528,0,0,0,5.625,8.542v3.432a.25.25,0,0,0,.436.167A8.029,8.029,0,0,1,7.273,11.046Z', 'M10.02,9.748a.251.251,0,0,0,.189-.243V8.542a1.958,1.958,0,1,1,3.916,0V9.6a.251.251,0,0,0,.178.239,8,8,0,0,1,1.212.475.249.249,0,0,0,.36-.224V8.542a3.708,3.708,0,1,0-7.416,0V9.958a.233.233,0,0,0,.327.214A7.877,7.877,0,0,1,10.02,9.748Z', 'M5.459,22.106A.252.252,0,0,0,5.254,22h-3A.249.249,0,0,1,2,21.75V2.25A.25.25,0,0,1,2.25,2H6.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H6.5a.95.95,0,0,0,.142-.01.249.249,0,0,0,.128-.436A8.055,8.055,0,0,1,5.459,22.106Z', 'M24,2a2,2,0,0,0-2-2H17.5a1,1,0,0,0,0,2h4.25a.25.25,0,0,1,.25.25v19.5a.249.249,0,0,1-.25.25h-3a.251.251,0,0,0-.2.106,8.023,8.023,0,0,1-1.312,1.448.25.25,0,0,0,.128.436A.959.959,0,0,0,17.5,24H22a2,2,0,0,0,2-2Z', 'M12,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,12,11Zm1.591,6.677,1.237,1.237a1,1,0,1,1-1.414,1.414l-1.237-1.237a.25.25,0,0,0-.353,0l-1.238,1.237a1,1,0,1,1-1.414-1.414l1.237-1.237a.249.249,0,0,0,0-.353L9.172,16.086a1,1,0,0,1,1.414-1.414l1.238,1.238a.25.25,0,0,0,.353,0l1.237-1.238a1,1,0,0,1,1.414,1.414l-1.237,1.238A.25.25,0,0,0,13.591,17.677Z']],
  TouchIdSmartphone1: ['touch-id-smartphone-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.962,1.987A4.8,4.8,0,0,1,22.25,6.542v4.722a.875.875,0,0,0,1.75,0V6.542A6.546,6.546,0,0,0,15.417.325a.875.875,0,1,0,.545,1.662Z', 'M22.333,15.626a.875.875,0,1,0-1.3-1.168,4.791,4.791,0,0,1-8.363-3.194V6.542a4.777,4.777,0,0,1,1.22-3.194.875.875,0,1,0-1.3-1.168,6.527,6.527,0,0,0-1.666,4.362v4.722a6.541,6.541,0,0,0,11.416,4.362Z', 'M15.5,11.264a.875.875,0,0,0-1.75,0,3.709,3.709,0,1,0,7.417,0V6.542a3.709,3.709,0,1,0-7.417,0V7.958a.875.875,0,0,0,1.75,0V6.542a1.959,1.959,0,1,1,3.917,0v4.722a1.959,1.959,0,1,1-3.917,0Z', 'M18.333,10.792V7.958a.875.875,0,1,0-1.75,0v2.834a.875.875,0,1,0,1.75,0Z', 'M15.962,1.987A4.8,4.8,0,0,1,22.25,6.542v4.722a.875.875,0,0,0,1.75,0V6.542A6.546,6.546,0,0,0,15.417.325a.875.875,0,1,0,.545,1.662Z', 'M22.333,15.626a.875.875,0,1,0-1.3-1.168,4.791,4.791,0,0,1-8.363-3.194V6.542a4.777,4.777,0,0,1,1.22-3.194.875.875,0,1,0-1.3-1.168,6.527,6.527,0,0,0-1.666,4.362v4.722a6.541,6.541,0,0,0,11.416,4.362Z', 'M15.5,11.264a.875.875,0,0,0-1.75,0,3.709,3.709,0,1,0,7.417,0V6.542a3.709,3.709,0,1,0-7.417,0V7.958a.875.875,0,0,0,1.75,0V6.542a1.959,1.959,0,1,1,3.917,0v4.722a1.959,1.959,0,1,1-3.917,0Z', 'M14.2,19a.25.25,0,0,0-.238.172.439.439,0,0,1-.043.1.5.5,0,0,1-.422.232H2.5A.5.5,0,0,1,2,19V3.5A.5.5,0,0,1,2.5,3H9.526a.249.249,0,0,0,.225-.142A8.554,8.554,0,0,1,11.093.846a2.952,2.952,0,0,1,.435-.395A.25.25,0,0,0,11.38,0H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H13a3,3,0,0,0,3-3V19.25a.25.25,0,0,0-.25-.25Z', 'M18.333,10.792V7.958a.875.875,0,1,0-1.75,0v2.834a.875.875,0,1,0,1.75,0Z']],
  TouchIdUser: ['touch-id-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.229,21.515a7.629,7.629,0,0,1-1.824.219.75.75,0,0,0,0,1.5,8.9,8.9,0,0,0,1.513-.125.251.251,0,0,0,.2-.208,1.816,1.816,0,0,1,.1-.377c.088-.225.185-.444.289-.657a.25.25,0,0,0-.284-.352Z', 'M17.155,9.264v.271a.249.249,0,0,0,.285.247,5.082,5.082,0,0,1,.95-.042.247.247,0,0,0,.186-.068.25.25,0,0,0,.079-.182V9.264a9.153,9.153,0,0,0-1.931-5.65.748.748,0,1,0-1.18.92A7.685,7.685,0,0,1,17.155,9.264Z', 'M6.389,21.129a7.74,7.74,0,0,1-4.736-7.143V12.1a.75.75,0,0,0-1.5,0v1.889A9.235,9.235,0,0,0,5.805,22.51a.74.74,0,0,0,.292.059.75.75,0,0,0,.292-1.44Z', 'M.876,9.541H.917a.75.75,0,0,0,.749-.709A7.752,7.752,0,0,1,13.281,2.552a.75.75,0,0,0,.75-1.3A9.252,9.252,0,0,0,.168,8.751.749.749,0,0,0,.876,9.541Z', 'M14.47,11.04A.25.25,0,0,0,14.738,11a4.873,4.873,0,0,1,.95-.641.25.25,0,0,0,.136-.223V9.264a6.418,6.418,0,0,0-8.419-6.1.751.751,0,0,0,.46,1.43,5.065,5.065,0,0,1,1.54-.25,4.928,4.928,0,0,1,4.919,4.92v1.549A.251.251,0,0,0,14.47,11.04Z', 'M4.624,4.984a6.393,6.393,0,0,0-1.64,4.28v4.72a6.414,6.414,0,0,0,10.98,4.51.251.251,0,0,0,.02-.326,5.407,5.407,0,0,1-.537-.854.234.234,0,0,0-.383-.05,4.915,4.915,0,0,1-8.58-3.28V9.264a4.948,4.948,0,0,1,1.25-3.28.747.747,0,1,0-1.11-1Z', 'M7.32,13.986a.75.75,0,0,0-1.5,0,3.584,3.584,0,0,0,7.167,0V9.264a3.584,3.584,0,0,0-7.167,0v1.417a.75.75,0,0,0,1.5,0V9.264a2.084,2.084,0,0,1,4.167,0v4.722a2.084,2.084,0,0,1-4.167,0Z', 'M10.153,13.514V10.681a.75.75,0,0,0-1.5,0v2.833a.75.75,0,0,0,1.5,0Z', 'M23.8,22.969a6.13,6.13,0,0,0-3.83-3.677.25.25,0,0,1-.028-.465,4.252,4.252,0,1,0-3.619-.024.25.25,0,0,1-.034.464,6.128,6.128,0,0,0-3.891,3.7.749.749,0,0,0,.7,1.017h10a.75.75,0,0,0,.7-1.017ZM15.9,14.986a2.174,2.174,0,0,1,.125-.72.251.251,0,0,1,.152-.152.255.255,0,0,1,.214.021,5.648,5.648,0,0,0,2.944.851,5.239,5.239,0,0,0,.765-.056.251.251,0,0,1,.285.266,2.247,2.247,0,0,1-4.485-.21Z']],
  TouchIdLock1: ['touch-id-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5ZM13.213,22.075A4.255,4.255,0,0,1,7.75,18V16a4.249,4.249,0,0,1,.176-1.214.75.75,0,0,1,1.438.428A2.742,2.742,0,0,0,9.25,16v2A2.752,2.752,0,0,0,12,20.75a2.789,2.789,0,0,0,.787-.113.75.75,0,0,1,.426,1.438ZM12,15.625a.625.625,0,0,1,0-1.25A1.627,1.627,0,0,1,13.625,16v1.5a.625.625,0,0,1-1.25,0V16A.375.375,0,0,0,12,15.625Zm-.375.875V18a.375.375,0,0,0,.375.375.625.625,0,0,1,0,1.25A1.626,1.626,0,0,1,10.375,18V16.5a.625.625,0,0,1,1.25,0ZM16.25,18a4.218,4.218,0,0,1-.41,1.823.75.75,0,1,1-1.354-.645A2.727,2.727,0,0,0,14.75,18V16a2.75,2.75,0,0,0-4.167-2.357.75.75,0,0,1-.774-1.285A4.25,4.25,0,0,1,16.25,16Zm0-9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5V6.75a4.25,4.25,0,0,1,8.5,0Z']],
  TouchId1: ['touch-id-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.422,3.912a.875.875,0,1,0-1.384,1.071,7.547,7.547,0,0,1,1.587,4.656v4.722A7.633,7.633,0,0,1,12,21.986a.875.875,0,0,0,0,1.75,9.385,9.385,0,0,0,9.375-9.375V9.639A9.281,9.281,0,0,0,19.422,3.912Z', 'M9.035,21.388a7.613,7.613,0,0,1-4.66-7.027V12.472a.875.875,0,0,0-1.75,0v1.889A9.358,9.358,0,0,0,8.354,23a.875.875,0,0,0,.681-1.612Z', 'M3.465,10.041l.049,0a.876.876,0,0,0,.873-.827A7.627,7.627,0,0,1,15.814,3.035a.875.875,0,1,0,.877-1.514A9.376,9.376,0,0,0,2.64,9.12.873.873,0,0,0,3.465,10.041Z', 'M18.542,14.361V9.639A6.547,6.547,0,0,0,9.958,3.422.875.875,0,1,0,10.5,5.085a4.8,4.8,0,0,1,6.289,4.554v4.722a.875.875,0,1,0,1.75,0Z', 'M8.36,5.209a.874.874,0,0,0-1.235.069A6.527,6.527,0,0,0,5.458,9.639v4.722a6.542,6.542,0,0,0,11.417,4.362.875.875,0,1,0-1.3-1.167,4.792,4.792,0,0,1-8.364-3.195V9.639a4.786,4.786,0,0,1,1.22-3.194A.876.876,0,0,0,8.36,5.209Z', 'M10.042,14.361a.875.875,0,0,0-1.75,0,3.708,3.708,0,1,0,7.416,0V9.639a3.708,3.708,0,0,0-7.416,0v1.417a.875.875,0,0,0,1.75,0V9.639a1.958,1.958,0,0,1,3.916,0v4.722a1.958,1.958,0,1,1-3.916,0Z', 'M12.875,13.889V11.056a.875.875,0,1,0-1.75,0v2.833a.875.875,0,0,0,1.75,0Z']],
  TouchFinger: ['touch-finger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.073,14.779l-5.079-1.823V7.5a2,2,0,0,0-4,0v8.461l-.826-1.138a1.545,1.545,0,0,0-1.2-.558l-.99.019a1.476,1.476,0,0,0-1.3,2.179l3.735,6.773A1.464,1.464,0,0,0,10.7,24h6.388a1.478,1.478,0,0,0,1.378-.989l1.519-6.68a.461.461,0,0,0,.013-.111A1.434,1.434,0,0,0,19.073,14.779Z', 'M6.1,11.9a1,1,0,0,0,.473-1.333A5.93,5.93,0,0,1,6,8,6,6,0,0,1,18,8a5.93,5.93,0,0,1-.577,2.57A1,1,0,0,0,17.9,11.9a1.023,1.023,0,0,0,1.333-.473A7.928,7.928,0,0,0,20,8,8,8,0,0,0,4,8a7.928,7.928,0,0,0,.771,3.43A1,1,0,0,0,6.1,11.9Z']],
  TouchId3: ['touch-id-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,0H1A1,1,0,0,0,0,1V23a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V1A1,1,0,0,0,23,0ZM12,4.848a4.807,4.807,0,0,0-1.5.237.875.875,0,0,1-.546-1.662A6.547,6.547,0,0,1,18.542,9.64v4.721a.875.875,0,1,1-1.75,0V9.64A4.8,4.8,0,0,0,12,4.848Zm0,1.083A3.713,3.713,0,0,1,15.708,9.64v4.721a3.708,3.708,0,1,1-7.416,0,.875.875,0,0,1,1.75,0,1.958,1.958,0,1,0,3.916,0V9.64a1.958,1.958,0,1,0-3.916,0v1.416a.875.875,0,0,1-1.75,0V9.64A3.713,3.713,0,0,1,12,5.931Zm-.875,7.959V11.056a.875.875,0,1,1,1.75,0V13.89a.875.875,0,0,1-1.75,0Zm-2.7-7.445a4.78,4.78,0,0,0-1.221,3.2v4.721a4.792,4.792,0,0,0,8.364,3.2.875.875,0,1,1,1.3,1.167A6.542,6.542,0,0,1,5.458,14.361V9.64A6.528,6.528,0,0,1,7.125,5.277a.875.875,0,0,1,1.3,1.168Z']],
  TouchID5: ['touch-id-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.671,5.113a4.8,4.8,0,0,1,6.287,4.554v4.722a.875.875,0,0,0,1.75,0V9.667a6.543,6.543,0,0,0-8.583-6.216.875.875,0,1,0,.546,1.662Z', 'M17.042,18.751a.875.875,0,1,0-1.3-1.168,4.791,4.791,0,0,1-8.363-3.194V9.667A4.779,4.779,0,0,1,8.6,6.473a.875.875,0,0,0-1.3-1.168A6.528,6.528,0,0,0,5.625,9.667v4.722a6.542,6.542,0,0,0,11.417,4.362Z', 'M10.208,14.389a.875.875,0,0,0-1.75,0,3.709,3.709,0,1,0,7.417,0V9.667a3.709,3.709,0,1,0-7.417,0v1.416a.875.875,0,0,0,1.75,0V9.667a1.959,1.959,0,1,1,3.917,0v4.722a1.959,1.959,0,1,1-3.917,0Z', 'M13.042,13.917V11.083a.875.875,0,0,0-1.75,0v2.834a.875.875,0,0,0,1.75,0Z', 'M0,2A2,2,0,0,1,2,0H6.5a1,1,0,0,1,0,2H2.25A.25.25,0,0,0,2,2.25v19.5a.249.249,0,0,0,.25.25H6.5a1,1,0,0,1,0,2H2a2,2,0,0,1-2-2Z', 'M24,2a2,2,0,0,0-2-2H17.5a1,1,0,0,0,0,2h4.25a.25.25,0,0,1,.25.25v19.5a.249.249,0,0,1-.25.25H17.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2Z']],
  TouchIdTarget: ['touch-id-target', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.037,20.566a7.5,7.5,0,0,1-11.9-5.623,1,1,0,0,0-2,.115,9.5,9.5,0,0,0,15.073,7.125,1,1,0,1,0-1.177-1.617Z', 'M1.125,12a1,1,0,0,0,1-1V9.5A7.5,7.5,0,0,1,9.625,2a6.15,6.15,0,0,1,.883.057.253.253,0,0,0,.236-.1A7.917,7.917,0,0,1,11.932.692a.251.251,0,0,0-.1-.433A9.31,9.31,0,0,0,9.625,0a9.509,9.509,0,0,0-9.5,9.5V11A1,1,0,0,0,1.125,12Z', 'M18.818,14.6a8.213,8.213,0,0,1-1.693.179h0a.007.007,0,0,0-.008.008,7.356,7.356,0,0,1-.65,2.8.991.991,0,0,0,.5,1.32.978.978,0,0,0,.41.09,1,1,0,0,0,.91-.59,9.237,9.237,0,0,0,.835-3.556.251.251,0,0,0-.3-.253Z', 'M8.939,6.572a.249.249,0,0,0,.2-.233,7.6,7.6,0,0,1,.224-1.5.25.25,0,0,0-.265-.31A5.5,5.5,0,0,0,4.125,10v4a5.48,5.48,0,0,0,.93,3.06.986.986,0,0,0,1.38.27,1,1,0,0,0,.28-1.39A3.412,3.412,0,0,1,6.125,14V10A3.5,3.5,0,0,1,8.939,6.572Z', 'M9.015,19.47a6.078,6.078,0,0,0,.61.03,5.506,5.506,0,0,0,5.445-4.762.248.248,0,0,0-.178-.273,7.549,7.549,0,0,1-1.509-.619.175.175,0,0,0-.258.154,3.5,3.5,0,0,1-3.5,3.5c-.13,0-.26-.01-.39-.02a1,1,0,0,0-.22,1.99Z', 'M9.517,9.26a.25.25,0,0,0-.352-.147.994.994,0,0,0-.54.887v4a1,1,0,0,0,2,0V11.524a.249.249,0,0,0-.049-.149A8.182,8.182,0,0,1,9.517,9.26Z', 'M23.125,6.027h-.344a.249.249,0,0,1-.246-.206,5.506,5.506,0,0,0-4.454-4.454.25.25,0,0,1-.206-.246V.777a.75.75,0,0,0-1.5,0v.344a.249.249,0,0,1-.207.246,5.505,5.505,0,0,0-4.453,4.454.249.249,0,0,1-.246.206h-.344a.75.75,0,0,0,0,1.5h.344a.25.25,0,0,1,.246.207,5.505,5.505,0,0,0,4.454,4.454.25.25,0,0,1,.206.246v.343a.75.75,0,1,0,1.5,0v-.343a.249.249,0,0,1,.207-.246,5.507,5.507,0,0,0,4.453-4.454.251.251,0,0,1,.246-.207h.344a.75.75,0,0,0,0-1.5Zm-3,1.5h.088a.251.251,0,0,1,.238.328A3.512,3.512,0,0,1,18.2,10.1a.249.249,0,0,1-.327-.238V9.777a.75.75,0,0,0-1.5,0v.088a.249.249,0,0,1-.327.238A3.508,3.508,0,0,1,13.8,7.855a.251.251,0,0,1,.238-.328h.088a.75.75,0,0,0,0-1.5h-.088a.249.249,0,0,1-.2-.1A.252.252,0,0,1,13.8,5.7a3.508,3.508,0,0,1,2.249-2.248.249.249,0,0,1,.327.238v.087a.75.75,0,1,0,1.5,0V3.69a.249.249,0,0,1,.327-.238A3.512,3.512,0,0,1,20.451,5.7a.252.252,0,0,1-.036.224.249.249,0,0,1-.2.1h-.088a.75.75,0,0,0,0,1.5Z', 'M16.125 6.778 A1.000 1.000 0 1 0 18.125 6.778 A1.000 1.000 0 1 0 16.125 6.778 Z']],
  TouchIdSmartphone: ['touch-id-smartphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,0H7A3,3,0,0,0,4,3V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V3A3,3,0,0,0,17,0Zm1,19a.5.5,0,0,1-.5.5H6.5A.5.5,0,0,1,6,19V3.5A.5.5,0,0,1,6.5,3h11a.5.5,0,0,1,.5.5Z', 'M12,6.25a4.243,4.243,0,0,0-2.191.608.75.75,0,0,0,.774,1.285A2.75,2.75,0,0,1,14.75,10.5v2a2.727,2.727,0,0,1-.264,1.178.75.75,0,1,0,1.354.644,4.21,4.21,0,0,0,.41-1.822v-2A4.255,4.255,0,0,0,12,6.25Z', 'M12.787,15.137A2.789,2.789,0,0,1,12,15.25,2.752,2.752,0,0,1,9.25,12.5v-2a2.742,2.742,0,0,1,.114-.786.75.75,0,0,0-1.438-.428A4.249,4.249,0,0,0,7.75,10.5v2a4.252,4.252,0,0,0,5.463,4.074.749.749,0,1,0-.426-1.437Z', 'M13,12.625A.625.625,0,0,0,13.625,12V10.5A1.627,1.627,0,0,0,12,8.875a.625.625,0,0,0,0,1.25.375.375,0,0,1,.375.375V12A.625.625,0,0,0,13,12.625Z', 'M10.375,11v1.5A1.626,1.626,0,0,0,12,14.125a.625.625,0,0,0,0-1.25.375.375,0,0,1-.375-.375V11a.625.625,0,0,0-1.25,0Z']],
  TouchIdSearch: ['touch-id-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.425,21.588a.248.248,0,0,0-.231-.06,7.714,7.714,0,0,1-1.919.243.743.743,0,0,0,0,1.486,9.018,9.018,0,0,0,3-.5.248.248,0,0,0,.057-.439A7.249,7.249,0,0,1,11.425,21.588Z', 'M16.954,9.416v.063a.217.217,0,0,0,.189.215,6.675,6.675,0,0,1,.981.207.247.247,0,0,0,.316-.238V9.416a9.072,9.072,0,0,0-1.912-5.6.741.741,0,0,0-1.04-.138.733.733,0,0,0-.129,1.04A7.663,7.663,0,0,1,16.954,9.416Z', 'M6.289,21.169A7.667,7.667,0,0,1,1.6,14.092V12.221a.744.744,0,0,0-1.487,0v1.871a9.151,9.151,0,0,0,5.6,8.445A.722.722,0,0,0,6,22.6a.743.743,0,0,0,.289-1.427Z', 'M.826,9.688H.867a.743.743,0,0,0,.742-.7,7.894,7.894,0,0,1,7.666-7.5,7.952,7.952,0,0,1,3.842,1.277.741.741,0,0,0,1.015-.27,1.069,1.069,0,0,0-.27-1.264A9.161,9.161,0,0,0,9.275,0,9.38,9.38,0,0,0,.124,8.906.743.743,0,0,0,.826,9.688Z', 'M14.246,9.808a.247.247,0,0,0,.213.045,6.7,6.7,0,0,1,1.01-.175.186.186,0,0,0,.167-.185V9.416A6.359,6.359,0,0,0,7.294,3.371a.74.74,0,0,0-.476.942.749.749,0,0,0,.931.475A4.705,4.705,0,0,1,9.275,4.54,4.885,4.885,0,0,1,14.15,9.416v.2A.246.246,0,0,0,14.246,9.808Z', 'M5.639,6.165a.739.739,0,0,0-.049-1.05.749.749,0,0,0-1.051.06A6.334,6.334,0,0,0,2.914,9.416v4.676a6.369,6.369,0,0,0,6.361,6.361,5.817,5.817,0,0,0,.747-.045.248.248,0,0,0,.182-.371,6,6,0,0,1-.441-.918.247.247,0,0,0-.246-.16c-.081,0-.163.008-.242.008A4.884,4.884,0,0,1,4.4,14.092V9.416A4.9,4.9,0,0,1,5.639,6.165Z', 'M7.214,14.092a.743.743,0,0,0-1.486,0,3.543,3.543,0,0,0,3.547,3.547.075.075,0,0,0,.058-.027.073.073,0,0,0,.017-.06,6.352,6.352,0,0,1-.075-.983c0-.079,0-.158,0-.237a.186.186,0,0,0-.17-.2A2.051,2.051,0,0,1,7.214,14.092Z', 'M11.479,11.3a.247.247,0,0,0,.264-.035,7.007,7.007,0,0,1,1.033-.723.094.094,0,0,0,.046-.081V9.416a3.547,3.547,0,1,0-7.094,0v1.4a.743.743,0,0,0,1.486,0v-1.4a2.061,2.061,0,1,1,4.122,0v1.659A.248.248,0,0,0,11.479,11.3Z', 'M9.577,14.3a.251.251,0,0,0,.136-.148,4.532,4.532,0,0,1,.278-.655.256.256,0,0,0,.027-.115V10.812a.743.743,0,1,0-1.486,0v2.815a.749.749,0,0,0,.743.743A.765.765,0,0,0,9.577,14.3Z', 'M23.527,21.886,21.02,19.379a.248.248,0,0,1-.039-.3,5.429,5.429,0,0,0,.737-2.73,5.479,5.479,0,1,0-5.479,5.478,5.426,5.426,0,0,0,2.73-.737.25.25,0,0,1,.3.039l2.507,2.507a1.238,1.238,0,0,0,1.751-1.751Zm-7.288-2.04a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,16.239,19.846Z']],
  TouchIdApproved: ['touch-id-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.557,21.65l-.006,0H10.54a7.428,7.428,0,0,1-1.165.089.75.75,0,0,0,0,1.5,9.344,9.344,0,0,0,1.764-.167.25.25,0,0,0,.144-.407A7.856,7.856,0,0,1,10.557,21.65Z', 'M17.125,9.267a.22.22,0,0,0,.22.219h.03a7.711,7.711,0,0,1,.969.059.251.251,0,0,0,.281-.249V9.267A9.154,9.154,0,0,0,16.7,3.616a.748.748,0,0,0-1.05-.139.739.739,0,0,0-.13,1.049A7.736,7.736,0,0,1,17.125,9.267Z', 'M6.361,21.129a7.74,7.74,0,0,1-4.736-7.143V12.1a.75.75,0,0,0-1.5,0v1.888A9.235,9.235,0,0,0,5.777,22.51a.74.74,0,0,0,.292.059.75.75,0,0,0,.292-1.44Z', 'M.847,9.542H.889a.75.75,0,0,0,.748-.709A7.751,7.751,0,0,1,13.252,2.553.75.75,0,0,0,14,1.254,9.252,9.252,0,0,0,.139,8.752.75.75,0,0,0,.847,9.542Z', 'M14.4,9.944a.248.248,0,0,0,.23.03,8.248,8.248,0,0,1,1.09-.322.093.093,0,0,0,.073-.091V9.267a6.419,6.419,0,0,0-8.42-6.1.747.747,0,0,0-.48.95.756.756,0,0,0,.94.48,4.733,4.733,0,0,1,1.54-.25A4.93,4.93,0,0,1,14.3,9.267v.472A.249.249,0,0,0,14.4,9.944Z', 'M5.705,5.986a.746.746,0,0,0-.05-1.06.755.755,0,0,0-1.06.06,6.4,6.4,0,0,0-1.64,4.281v4.719a6.427,6.427,0,0,0,6.42,6.42c.068,0,.138,0,.209,0a.25.25,0,0,0,.225-.333,7.323,7.323,0,0,1-.278-1.034.159.159,0,0,0-.156-.129,4.929,4.929,0,0,1-4.92-4.92V9.267A4.95,4.95,0,0,1,5.705,5.986Z', 'M9.294,17.566a.08.08,0,0,0,.081-.08,7.656,7.656,0,0,1,.105-1.3.107.107,0,0,0-.105-.124A2.079,2.079,0,0,1,7.3,13.986a.75.75,0,0,0-1.5,0A3.576,3.576,0,0,0,9.294,17.566Z', 'M11.607,11.731a.249.249,0,0,0,.27-.049,7.907,7.907,0,0,1,.969-.782.252.252,0,0,0,.109-.207V9.267a3.58,3.58,0,1,0-7.16,0v1.409a.75.75,0,0,0,1.5,0V9.267a2.08,2.08,0,1,1,4.16,0V11.5A.251.251,0,0,0,11.607,11.731Z', 'M10.125,13.514V10.681a.75.75,0,1,0-1.5,0v2.833a.75.75,0,0,0,1.5,0Z', 'M17.375,10.986a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.375,10.986Zm3.474,5.355-2.905,3.874a1.751,1.751,0,0,1-2.64.186l-1.5-1.5a1,1,0,0,1,1.414-1.415l1.094,1.095a.251.251,0,0,0,.377-.027l2.559-3.412a1,1,0,0,1,1.6,1.2Z']]
};
exports["default"] = _default;